<template>
  <div class="secondary light--text" style="height: 270px">
    <v-flex class="mx-2 mt-4 mb-2">
      <h4 class=" text-h6 font-weight-bold">Celebrity Info</h4>
    </v-flex>
    <v-row class="mb-n6">
      <v-col md="5" class="ms-2">Commission</v-col>
      <v-col md="6" class="font-weight-medium" v-if="celebrity.commissionPercentage"> {{ celebrity.commissionPercentage }} <strong> %</strong> </v-col>
    </v-row>
    <v-row class="mb-n6">
      <v-col md="5" class="ms-2">Refferal Code</v-col>
      <v-col md="6" class="font-weight-medium" v-if="celebrity.customer.user.userId">
        {{ celebrity.customer.user.userId }}
      </v-col>
    </v-row>
    <v-row class="">
      <v-col md="5" class="ms-2">Description</v-col>
      <v-col md="6" class="font-weight-medium" v-if="celebrity.descriptionEn">
        {{ celebrity.descriptionEn | truncate(100, "...") }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    celebrity: {
      required: true,
    },
  },
  methods: {
    toPascalCase(string) {
      return `${string}`
        .replace(new RegExp(/[-_]+/, "g"), " ")
        .replace(new RegExp(/[^\w\s]/, "g"), "")
        .replace(new RegExp(/\s+(.)(\w+)/, "g"), ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`)
        .replace(new RegExp(/\s/, "g"), "")
        .replace(new RegExp(/\w/), s => s.toUpperCase());
    },
  },
  computed: {
    age: {
      get: function() {
        if (this.celebrity.user.dob) {
          let dateofbirth = new Date(parseInt(this.celebrity.user.dob));
          var ageDifMs = Date.now() - dateofbirth.getTime();
          var ageDate = new Date(ageDifMs);
          return Math.abs(ageDate.getUTCFullYear() - 1970);
        } else return "";
      },
      set: () => null,
    },
  },
};
</script>
